import * as riot from 'riot'
import App from './components/app.riot'
import PullToRefresh from 'pulltorefreshjs';

const ptr = PullToRefresh.init({
  mainElement: 'body',
  onRefresh() {
    window.location.reload();
  }
});

const mountApp = riot.component(App)

const app = mountApp(
  document.getElementById('appContainer'),
  { }
)